import React, {Component} from 'react';
import {observer} from 'mobx-react';
import ServerAPI from '../ServerAPI';
import {List, ListItem} from 'material-ui/List';
import AppModel from '../DataModel/AppModel';
import MachineSERPElement from './MachineSERPElement';

export default
@observer class MachineSearchResult extends Component {

  render() {
    let selectionHandler = this.props.onSelect;
    return (
      <List>
        { AppModel.machineSearchResult.map(function(m) {
            return <MachineSERPElement  key={m.id}
                                        machine={m}
                                        onSelect={selectionHandler} />
            })
        }
      </List>
    );
  }
};



/** WEBPACK FOOTER **
 ** ./src/components/MachineSearchResult.jsx
 **/